'use client';

import * as React from 'react';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';

import { store } from './store';
persistStore(store);

export default function StoreProvider({ children }) {
	return <Provider store={store}>{children}</Provider>;
}
